import { createModel } from "hox";
import useStorageState from "../hooks/useStorageState";
import { IPgProps, ISelectOptions } from "@/types/AppTypes";
import { PaginationProps } from "antd/es/pagination";
import { useState } from "react";
import { ISelectOption } from "@/components/YhFormBox/Types";

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size ?? pg.pageSize,
        current: pg.current ?? pg.pageNum
    }
}

export function fn(): Promise<ISelectOption[]> {
    let arr: ISelectOption[] = [];
    return Promise.resolve(arr)
}

export type RoleType = {
    id: string,
    name: String,
};
export type UserType = {
    id: string,
    userName: string,
    password: String,
    token: string,
    shopId: string,
    shopName: string,
    loginType?: "account" | "token"
    [key: string]: any
}

export type LoadingType = { loadingVisible: boolean, txt: string };

type GlobalModelType = {
    user: UserType,
    setUser: (e: UserType) => void,
    resetUser: () => void,
    toggleMenu: () => void,
    cm: CmType,
    resetCm: () => void,
    loadingInfo: LoadingType,
    setLoadingInfo: (origin: LoadingType) => void,

    resourceAuth: string[],
    setResourceAuth: (origin: string[]) => void

    menuAuth: string[],
    setMenuAuth: (origin: string[]) => void,
};


const initUserState = {
    id: "",
    userName: "",
    password: "",
    token: "",
    shopId: "",
    shopName: "",
}

type CmType = {
    collapsed: boolean
}
const initCmState = {
    collapsed: false
}

function useModel(): GlobalModelType {
    //用户所有菜单权限
    const [menuAuth, setMenuAuth] = useStorageState<string[]>("user.menus", []);
    //用户所有资源权限
    const [resourceAuth, setResourceAuth] = useStorageState<string[]>("user.resource", []);
    //用户所有信息
    const [user, setUser, resetUser] = useStorageState<UserType>('user', initUserState);

    const [cm, setCm, resetCm] = useStorageState<CmType>('cm', initCmState);

    //全局loading
    const [loadingInfo, setLoadingInfo] = useState<LoadingType>({ loadingVisible: false, txt: "" });

    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed
        })
    }


    return {
        user, setUser, resetUser,
        cm, toggleMenu, resetCm,
        loadingInfo, setLoadingInfo,
        resourceAuth, setResourceAuth,
        menuAuth, setMenuAuth
    };
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel;
